import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Button, Collapse, Stack, Typography } from '@mui/material';
import React, { useId, useState } from 'react';

export type StepHelpItem = {
  question: string;
  answer: string;
};

export const StepHelp = ({ items }: { items: StepHelpItem[] }) => {
  const [open, setOpen] = useState(false);
  const contentId = useId();

  return (
    <Stack spacing={1} sx={{ minWidth: 0 }}>
      <Button
        color="inherit"
        variant="outlined"
        size="small"
        startIcon={<HelpOutlineIcon />}
        aria-expanded={open}
        aria-controls={contentId}
        sx={{ alignSelf: 'flex-start', textTransform: 'none', fontWeight: 600 }}
        onClick={() => setOpen((current) => !current)}
      >
        {open ? 'Hide help' : 'I need help with this step'}
      </Button>
      <Collapse id={contentId} in={open} timeout="auto" unmountOnExit>
        <Stack spacing={1.25}>
          {items.map((item) => (
            <Stack key={item.question} spacing={0.25}>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {item.question}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {item.answer}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Collapse>
    </Stack>
  );
};
